import { Utils } from '@augloop/runtime-client';
var ExecutionWithThrottling = /** @class */ (function () {
    function ExecutionWithThrottling() {
        this.throttleInfoMap = new Map();
    }
    /**
     * Executes given workflow for the given tile id. executeCallback is called in all cases, except if we have consecutive calls to this method for the same tile id,
     * in a period that is less than throttlingInterval. In that case we postpone the execution until throttlingInterval miliseconds has passed from previous
     * executed event.
     */
    ExecutionWithThrottling.prototype.execute = function (tileId, workflow, executeCallback) {
        var _this = this;
        if (!workflow.throttleSettings.shouldBeThrottled || !(workflow.throttleSettings.throttlingInterval > 0)) {
            executeCallback();
        }
        else {
            var workflowThrottleInfo = this.getWorkflowThrottleInfo(workflow.name);
            // First tile event
            if (workflowThrottleInfo.currentTileId == undefined) {
                workflowThrottleInfo.currentTileId = tileId;
                workflowThrottleInfo.timeOfPreviousStartedEvent = Utils.getCurrentTimeMs();
                executeCallback();
                // All subsequent events
            }
            else if (workflowThrottleInfo.currentTileId === tileId) {
                var currentTime = Utils.getCurrentTimeMs();
                var delayTime = this.delayTime(workflowThrottleInfo, currentTime, workflow.throttleSettings.throttlingInterval);
                if (delayTime > 0) {
                    workflowThrottleInfo.latestCallback = executeCallback;
                    if (workflowThrottleInfo.lastTimeout == undefined) {
                        workflowThrottleInfo.lastTimeout = setTimeout(function () {
                            var workflowThrottleInfo = _this.getWorkflowThrottleInfo(workflow.name);
                            workflowThrottleInfo.lastTimeout = undefined;
                            workflowThrottleInfo.timeOfPreviousStartedEvent = Utils.getCurrentTimeMs();
                            // This will run the latest workflow that came in the current throttleTime miliseconds window
                            workflowThrottleInfo.latestCallback();
                        }, delayTime);
                    }
                }
                else {
                    // We will execute the workflow immediately
                    workflowThrottleInfo.timeOfPreviousStartedEvent = currentTime;
                    executeCallback();
                }
                // Different tile ids
            }
            else {
                // If there's a waiting workflow, execute it immediately
                if (workflowThrottleInfo.lastTimeout != undefined) {
                    clearTimeout(workflowThrottleInfo.lastTimeout);
                    workflowThrottleInfo.latestCallback();
                    workflowThrottleInfo.lastTimeout = undefined;
                }
                workflowThrottleInfo.currentTileId = tileId;
                workflowThrottleInfo.timeOfPreviousStartedEvent = Utils.getCurrentTimeMs();
                executeCallback();
            }
        }
    };
    /**
     * Returns the time for how long to delay the execution, if it's 0 no need to delay
     */
    ExecutionWithThrottling.prototype.delayTime = function (workflowThrottleInfo, currentTime, throttleTime) {
        var timeFromPreviousEvent = currentTime - workflowThrottleInfo.timeOfPreviousStartedEvent;
        return Math.max(throttleTime - timeFromPreviousEvent, 0);
    };
    /**
     * Get throttle info for workflow
     */
    ExecutionWithThrottling.prototype.getWorkflowThrottleInfo = function (name) {
        var throttleInfo = this.throttleInfoMap.get(name);
        if (!throttleInfo) {
            throttleInfo = {
                currentTileId: undefined,
                timeOfPreviousStartedEvent: -1,
                latestCallback: function () { },
                lastTimeout: undefined
            };
            this.throttleInfoMap.set(name, throttleInfo);
        }
        return throttleInfo;
    };
    return ExecutionWithThrottling;
}());
export { ExecutionWithThrottling };
//# sourceMappingURL=throttling.js.map